module.exports = __webpack_public_path__ + "media/src/images/icons/arrow-forward-2e51a2aae038d83eea583de43932ec5f.svg";